var $2d9c03101e09ccc5$exports = {};
$2d9c03101e09ccc5$exports = {
    "collapse": `\u{6298}\u{53E0}`,
    "expand": `\u{6269}\u{5C55}`
};


export {$2d9c03101e09ccc5$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
